import type { ButtonHTMLAttributes, ReactNode } from 'react'

interface AngledButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  tone?: 'gold' | 'accent' | 'neutral' | 'danger'
  /** Stretch to the full width of the container */
  block?: boolean
  children: ReactNode
}

// clip-path swallows borders and outlines, so the 1px border lives on the
// wrapper and keyboard focus is shown via :focus-within box-shadow.
export function AngledButton({ tone = 'neutral', block, children, className, style, ...rest }: AngledButtonProps) {
  const toneClass = tone === 'neutral' ? '' : ` tone-${tone}`
  return (
    <span
      className={`angled-wrap${toneClass}${className ? ` ${className}` : ''}`}
      style={block ? { display: 'flex', width: '100%' } : undefined}
    >
      <button
        className={`btn-angled${toneClass}`}
        style={block ? { flex: 1, justifyContent: 'center', ...style } : style}
        {...rest}
      >
        {children}
      </button>
    </span>
  )
}
